import React, { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { Link, useParams } from "react-router-dom";
import axios from "../../../axios";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  InputGroup,
  InputLeftElement,
  Input,
  InputRightAddon,
} from "@chakra-ui/react";
import { useToast } from '@chakra-ui/react'
import { MdEdit, MdDelete } from "react-icons/md";
import DeletePasswordModal from "../../../componant/DeletePasswordModal";
function ContestViewQ() {
    const {id}=useParams()
    console.log(id)
    const toast = useToast()
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();

  const [data, setData] = useState([]);
  const [newID, setNewID] = useState(null);
  const [language, setLanguage] = useState("english");
  const [search, setSearch] = useState("");
  const [contest, setContest] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
const [totalQuestions, setTotalQuestions] = useState(0);
  console.log(data);


  useEffect(() => {
    if (!id) return;
       axios
    .get(`getContestQuestionsByContestId/${id}?page=${currentPage}&limit=50`)
    .then((res) => {
      if (res.data) {
      console.log(res.data);
      const result = res.data.result;
    setData(result.questions || []);
setTotalPages(result.totalPages || 1);
setTotalQuestions(result.totalQuestions || 0);

      if (result?.contest) {
        setContest(result.contest);
      } else if (result?.contestName || result?.startTime || result?.createdOn) {
        setContest(result);
      }
    
      }
    })
    .catch((err) => {
        toast({
            title: `Something Went Wrong!`,
            status: "error",
            duration: 4000,
            isClosable: true,
             position:"top"
          });
    });

  }, [id, toast,currentPage]);

  useEffect(() => {
    if (!id || contest) return;

    axios
      .get("getAllContestForAdmin")
      .then((res) => {
        const result = res.data?.result;
        const contests = Array.isArray(result) ? result : result?.contests || [];
        const selectedContest = contests.find((item) => item._id === id);

        if (selectedContest) {
          setContest(selectedContest);
        }
      })
      .catch(() => {
        setContest(null);
      });
  }, [id, contest]);
  const handleDelete = () => {
    axios
      .delete(`deleteContestQuestion/${newID}`)
      .then((res) => {
        if (res.data) {
          console.log(res.data);
          toast({
            title: `Success! Question has been Deleted successfully`,
            status: "success",
            duration: 4000,
          isClosable: true,
          position:"top"
          });
          setData((prevData) => {
            if (Array.isArray(prevData)) {
              return prevData.filter((question) => question._id !== newID);
            }

            return {
              ...prevData,
              questions: (prevData?.questions || []).filter(
                (question) => question._id !== newID
              ),
            };
          });
          onClose();
        }
      })
      .catch((err) => {
        toast({
            title: `Something Went Wrong!`,
            status: "error",
            duration: 4000,
            isClosable: true,
             position:"top"
          });
      });
  };

  const questions = useMemo(() => {
    const questionList = Array.isArray(data) ? data : data?.questions || [];
    const searchText = search.trim().toLowerCase();

    if (!searchText) return questionList;

    return questionList.filter((question) => {
      const searchableText = [
        question.question,
        question.questionHin,
        question.answer,
        question.answerHin,
        question.quesType,
        ...(Array.isArray(question.options) ? question.options : []),
        ...(Array.isArray(question.optionsHin) ? question.optionsHin : []),
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return searchableText.includes(searchText);
    });
  }, [data, search]);

  const getQuestionText = (question) => {
    if (language === "hindi") {
      return question.questionHin || question.question || "Question not available";
    }

    return question.question || question.questionHin || "Question not available";
  };

  const getOptions = (question) => {
    const options = language === "hindi" ? question.optionsHin : question.options;
    const fallbackOptions = language === "hindi" ? question.options : question.optionsHin;
    const selectedOptions = Array.isArray(options) && options.length ? options : fallbackOptions;

    if (Array.isArray(selectedOptions)) return selectedOptions;
    if (typeof selectedOptions === "string") {
      return selectedOptions.split(",").map((option) => option.trim()).filter(Boolean);
    }

    return [];
  };

  const getAnswer = (question) => {
    if (language === "hindi") {
      return question.answerHin || question.answer || "";
    }

    return question.answer || question.answerHin || "";
  };

  const isCorrectOption = (option, answer) =>
    option?.toString().trim().toLowerCase() === answer?.toString().trim().toLowerCase();

  const contestName =
    language === "hindi"
      ? contest?.contestNameHin || contest?.contestName
      : contest?.contestName || contest?.contestNameHin;

  const contestDate = contest?.startTime || contest?.contestDate || contest?.createdOn;

  return (
    <div
      className="lg:py-8 py-4 bg-bgWhite min-h-screen"
     
    >
      <section className="md:p-1">
        <div>
          
          <div className="flex flex-col gap-4 lg:flex-row lg:justify-between lg:items-center">
            <div>
              <h2 className="text-xl font-bold text-purple text-oswald">
                Contest Answer Key
              </h2>
              <p className="text-sm text-gray-500 mt-1">
                {questions.length} question{questions.length === 1 ? "" : "s"}
              </p>
            </div>
             <div className="mt-0 rounded-lg border border-purple/30 bg-white p-4 shadow-sm">
            <div className="grid gap-3 md:grid-cols-2">
              <div>
                <p className="text-xs font-semibold uppercase text-gray-500">
                  Contest Name : {contestName || "Contest name not available"}
                </p>  
                {/* <p className="mt-1 text-lg font-bold text-gray-900">
                  {contestName || "Contest name not available"}
                </p> */}
              </div>
              <div>
                <p className="text-xs font-semibold uppercase text-gray-500">
                  Date : {contestDate
                    ? dayjs(contestDate).format("D MMM, YYYY h:mm A")
                    : "Date not available"}
                </p>
                {/* <p className="mt-1 text-lg font-bold text-gray-900">
                  {contestDate
                    ? dayjs(contestDate).format("D MMM, YYYY h:mm A")
                    : "Date not available"}
                </p> */}
              </div>
            </div>
          </div>
            <div className="w-full lg:w-96">
              <InputGroup borderRadius={5} size="sm">
                <InputLeftElement
                  pointerEvents="none"
                  // children={<Search2Icon color="gray.600" />}
                />
                <Input
                  type="text"
                  placeholder="Search..."
                  border="1px solid #949494"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <InputRightAddon p={0} border="none">
                  <Button
                    className="bg-purple"
                    colorScheme="#FF782D"
                    size="sm"
                    borderLeftRadius={0}
                    borderRightRadius={3.3}
                    border="1px solid #949494"
                  >
                    Search
                  </Button>
                </InputRightAddon>
              </InputGroup>
            </div>

            <div className="flex gap-2 rounded-md border border-purple p-1 bg-white w-fit">
              <button
                type="button"
                onClick={() => setLanguage("english")}
                className={`px-4 py-2 rounded text-sm font-semibold ${
                  language === "english"
                    ? "bg-purple text-white"
                    : "text-purple hover:bg-purple/10"
                }`}
              >
                English
              </button>
              <button
                type="button"
                onClick={() => setLanguage("hindi")}
                className={`px-4 py-2 rounded text-sm font-semibold ${
                  language === "hindi"
                    ? "bg-purple text-white"
                    : "text-purple hover:bg-purple/10"
                }`}
              >
                Hindi
              </button>
            </div>
          </div>

         

          <div className="mt-5 space-y-4">
            {questions.length ? (
              questions.map((question, index) => {
                const options = getOptions(question);
                const answer = getAnswer(question);
                const hasCorrectOption = options.some((option) =>
                  isCorrectOption(option, answer)
                );

                return (
                  <div
                    key={question._id || index}
                    className="bg-white border border-gray-200 rounded-lg shadow-sm p-4"
                  >
                    <div className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
                      <div className="flex gap-3">
                        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-purple text-sm font-bold text-white">
                          {index + 1}
                        </span>
                        <div>
                          <p className="text-base font-semibold text-gray-900">
                            {getQuestionText(question)}
                          </p>
                          {question.quesType && (
                            <span className="mt-2 inline-flex rounded bg-gray-100 px-2 py-1 text-xs font-semibold uppercase text-gray-600">
                              {question.quesType}
                            </span>
                          )}
                        </div>
                      </div>

                      <Menu>
                        <MenuButton
                          as={Button}
                          className="bg-bgBlue"
                          colorScheme="bgBlue"
                          size="sm"
                          onClick={() => setNewID(question._id)}
                        >
                          Actions
                        </MenuButton>
                        <MenuList>
                          <Link to={`/dash/editcontest-question/${question._id}&${id}`}>
                            <MenuItem>
                              <MdEdit className="mr-4" /> Edit
                            </MenuItem>
                          </Link>

                          <MenuItem
                            onClick={() => {
                              setNewID(question._id);
                              onOpen();
                            }}
                          >
                            <MdDelete className="mr-4" />
                            Delete
                          </MenuItem>
                        </MenuList>
                      </Menu>
                    </div>

                    <div className="mt-4 grid gap-3 md:grid-cols-2">
                      {options.map((option, optionIndex) => {
                        const isCorrect = isCorrectOption(option, answer);

                        return (
                          <div
                            key={`${question._id || index}-${optionIndex}`}
                            className={`flex items-start gap-3 rounded-md border px-3 py-3 text-sm ${
                              isCorrect
                                ? "border-green-500 bg-green-50 text-green-800"
                                : "border-gray-200 bg-gray-50 text-gray-700"
                            }`}
                          >
                            <span
                              className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                                isCorrect
                                  ? "bg-green-600 text-white"
                                  : "bg-white text-gray-600 border border-gray-300"
                              }`}
                            >
                              {String.fromCharCode(65 + optionIndex)}
                            </span>
                            <span className="break-words">{option}</span>
                          </div>
                        );
                      })}
                    </div>

                    <div
                      className={`mt-4 rounded-md border px-3 py-2 text-sm font-semibold ${
                        hasCorrectOption
                          ? "border-green-500 bg-green-50 text-green-800"
                          : "border-red-500 bg-red-50 text-red-800"
                      }`}
                    >
                      Correct Answer: {answer || "Not available"}
                      {!hasCorrectOption && answer && (
                        <span className="ml-2 text-xs font-medium">
                          (Answer option se match nahi ho raha)
                        </span>
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="rounded-lg border border-dashed border-gray-300 bg-white p-8 text-center text-gray-500">
                No questions found.
              </div>
            )}
            {totalPages > 1 && (
  <div className="flex justify-between items-center mt-6">
    <Button
      size="sm"
      onClick={() => setCurrentPage((p) => p - 1)}
      isDisabled={currentPage === 1}
    >
      Previous
    </Button>

    <span>
      Page {currentPage} of {totalPages}
    </span>

    <Button
      size="sm"
      onClick={() => setCurrentPage((p) => p + 1)}
      isDisabled={currentPage === totalPages}
    >
      Next
    </Button>
  </div>
)}
          </div>
        </div>
        <DeletePasswordModal
          isOpen={isOpen}
          onClose={onClose}
          onConfirm={handleDelete}
          title="Delete Question"
          description="Password verify hone ke baad contest question delete hoga."
        />
       
      </section>
    </div>
  );
}

export default ContestViewQ;
